import React, { useEffect, useState } from 'react';
import { shape, string } from 'prop-types';
import axios from 'axios';
import queryString from 'query-string';

import BasePage from '../BasePage/BasePage';
import { isIdTokenValid, safeDecodeJwt } from '../../utils/jwt-utils';
import { getLink } from '../../../shared-with-server/product-name-utils';
import SignInButtonPanel from './Panels/SignInButtonPanel';
import ContinueButtonPanel from './Panels/ContinueButtonPanel';

const getButtonPanel = (workflow, decodedToken, destPath, emails) => {
  if (workflow === 'user-account-management') {
    return <ContinueButtonPanel decodedToken={decodedToken} />;
  }
  return <SignInButtonPanel decodedToken={decodedToken} destPath={destPath} emails={emails} />;
};

const AcceptEmailConfirmationPage = ({ destPath, brand }) => {
  const [emails, setEmails] = useState({ to: '', from: '' });
  const { token: encodedToken, workflow } = queryString.parse(location.search);
  const decodedToken = safeDecodeJwt(encodedToken);

  useEffect(
    () => {
      if (decodedToken) {
        axios.get(`/iam/accept-email?token=${encodedToken}`)
          .then((res) => {
            setEmails({ to: res.data?.to, from: res.data?.from });
            const redirectURL = res.data?.redirectURL;
            if (redirectURL.includes('/error')) {
              window.location.href = redirectURL;
            }
            if (res.status === 200 && isIdTokenValid(encodedToken)) {
              axios.put('/api/v2/token/renewal')
                .catch((err) => {
                  console.error('error renewing token', err);
                });
            }
          });
      }
    },
    [],
  );

  return (
    <BasePage brand={brand}>
      <h2>Your {brand.full} username/email address has been successfully updated.</h2>
      <div className="pad">
        <p className="description mainMessage">
          from: <br />
          <b>{emails.from}</b>
          <br />
          to: <br />
          <b>{emails.to}</b>
          <br />
          <br />
          Note that your password has not changed.
          <br />
          If you have any questions or concerns, please contact your sales representative or <a href={getLink(brand.short, 'support')}>technical support</a>.
        </p>
        <br />
        {getButtonPanel(workflow?.toLowerCase(), decodedToken, destPath, emails)}
      </div>
    </BasePage>
  );
};

AcceptEmailConfirmationPage.propTypes = {
  destPath: shape({
    dest: string,
    path: string,
    retURL: string,
  }),
  brand: shape({
    short: string.isRequired,
    full: string.isRequired,
  }).isRequired,
};

AcceptEmailConfirmationPage.defaultProps = {
  destPath: {
    retURL: null,
  },
};

export default AcceptEmailConfirmationPage;
